import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * PaymentIcon - Exibe ícone de forma de pagamento usando sprite
 * 
 * A imagem payments.png contém 12 ícones lado a lado, cada um com 300px de largura (total: 3600px).
 * O ícone exibido depende do display_order da forma de pagamento:
 * - Ordem 1 (Dinheiro): índice 0, posição 0px
 * - Ordem 2 (PIX): índice 1, posição 300px
 * - Ordem 3 (Débito): índice 2, posição 600px
 * - Ordem 4 (Crédito): índice 3, posição 900px
 * - Ordem 5 (Amil): índice 4, posição 1200px
 * - Ordem 6 (Bradesco): índice 5, posição 1500px
 * - E assim por diante...
 * 
 * @param {number} displayOrder - Ordem de exibição da forma de pagamento (1, 2, 3, 4, 5...)
 * @param {number} size - Tamanho da largura do ícone em pixels (padrão: 40). Altura é calculada mantendo proporção 3:2
 */
const PaymentIcon = ({ displayOrder, size = 40, sx = {} }) => {
  // A sprite tem 12 ícones, cada um com 300px de largura e 200px de altura (proporção 3:2)
  const iconWidth = 300;
  const iconHeight = 200;
  const totalIcons = 12;
  const spriteWidth = iconWidth * totalIcons; // 3600px
  
  // Mapeia displayOrder (1, 2, 3, 4, 5...) diretamente para índice (0, 1, 2, 3, 4...)
  // displayOrder 1 (Dinheiro) -> índice 0 -> posição 0px
  // displayOrder 2 (PIX) -> índice 1 -> posição 300px  
  // displayOrder 3 (Débito) -> índice 2 -> posição 600px
  // displayOrder 4 (Crédito) -> índice 3 -> posição 900px
  // displayOrder 5 (Amil) -> índice 4 -> posição 1200px
  const iconIndex = displayOrder - 1;
  const positionX = iconIndex * iconWidth;
  
  // Calcula altura mantendo proporção 3:2
  const width = size;
  const height = (size * iconHeight) / iconWidth; // Proporção 3:2
  
  // Escala proporcional para diferentes tamanhos
  const scale = size / iconWidth;
  
  return (
    <Box
      sx={{
        width: width,
        height: height,
        backgroundImage: 'url(/payments.png)',
        backgroundPosition: `-${positionX * scale}px 0`,
        backgroundSize: `${spriteWidth * scale}px ${iconHeight * scale}px`,
        backgroundRepeat: 'no-repeat',
        display: 'inline-block',
        ...sx,
      }}
      title={`Forma de pagamento ${displayOrder}`}
    />
  );
};

PaymentIcon.propTypes = {
  displayOrder: PropTypes.number.isRequired,
  size: PropTypes.number,
  sx: PropTypes.object,
};

export default PaymentIcon;
